const NewTabLink = ({ href, target, children, className }) => {
    const handleClick = (event) => {
        event.preventDefault(); // prevents the full page reload
        const targetWindow = window.open('', target);
        const absoluteUrl = new URL(href, window.location.origin).href;
        try {    
          if (targetWindow && targetWindow.location.href === absoluteUrl) {
            targetWindow.focus();
          } else {
            window.open(href, target);
          }
        } catch (e) {
          window.open(href, target);
        }
    };
    return <a href={href} target={target} onClick={handleClick} className={className}>{children}</a>;
};

export default NewTabLink;